"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSPPackageError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "NoSharePointPackage";
const messageKey = "plugins.spfx.cannotFindPackage";
class NoSPPackageError extends teamsfx_api_1.UserError {
    constructor(distFolder) {
        super({
            source: constants_1.Constants.DeployDriverName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey, distFolder),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey, distFolder),
        });
    }
}
exports.NoSPPackageError = NoSPPackageError;
//# sourceMappingURL=noSPPackageError.js.map